export class ObjectId {
    public static isDefault(id: string) {
        return id == "000000000000000000000000";
    }
}